export interface props {
  className?: string;
  count: number;
  height: string;
}

export const GenericLoadingElement = (props: props) => {
  const numberOfLoadingElements = Array.from(Array(props.count).keys());

  return (
    <div className={`animate-pulse-elevation0 pb-2 pt-2 mb-4 ${props.className}`}>
      {numberOfLoadingElements.map((_element, index) => {
        return <div key={index} className={`animate-pulse-elevation1 ${props.height} mt-2 first:mt-0 ml-2 mr-2`}></div>;
      })}
    </div>
  );
};
